<div class="pkt-form-field" [class.pkt-error-state]="!!errorMessage">
  <label *ngIf="label" class="pkt-label" [class.pkt-label--clamp]="labelLines" [style.--pkt-label-lines]="labelLines">
    {{ label }}<span *ngIf="required" class="pkt-required">*</span>
  </label>

  <mat-radio-group class="pkt-radio-group" [class.horizontal]="orientation === 'horizontal'" [disabled]="disabled"
    [(ngModel)]="value" (ngModelChange)="onRadioChange($event)">
    <div *ngFor="let opt of options; trackBy: trackByValue" class="pkt-radio-item"
      [class.pkt-radio-item--checked]="value === opt.value">
      <mat-radio-button [value]="opt.value" [disabled]="!!opt.disabled">
        <ng-container *ngIf="optionTemplate; else defaultOptionLabel"
          [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ $implicit: opt }"></ng-container>
        <ng-template #defaultOptionLabel>{{ opt.label }}</ng-template>
      </mat-radio-button>
      <span *ngIf="opt.hint && !optionTemplate" class="pkt-option-hint">{{ opt.hint }}</span>
    </div>
  </mat-radio-group>

  <div *ngIf="hint && !errorMessage" class="pkt-hint">{{ hint }}</div>
  <div *ngIf="errorMessage" class="pkt-error-msg">
    <span class="material-symbols-outlined">error</span>{{ errorMessage }}
  </div>
</div>